<a class="nav-link {{item.class}}" *ngIf="item.url" [routerLink]="[item.url]" routerLinkActive="active"
   [routerLinkActiveOptions]="{exact: item.exactMatch || false}" matRipple (click)="routeChange(item.class,$event,item.title,item.parentId);">
    <mat-icon class="nav-link-icon" *ngIf="item.icon" style="color: #02488e;">{{item.icon}}</mat-icon>
    <span class="nav-link-title">{{item.title}}</span>
    <span class="nav-link-badge" *ngIf="item.badge"
          [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
    </span>
</a>

<span class="nav-link" *ngIf="item.function" (click)="item.function()" matRipple>
    <mat-icon class="nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
    <span class="nav-link-title">{{item.title}}</span>
    <span class="nav-link-badge" *ngIf="item.badge"
          [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
    </span>
</span>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.html